module.exports = __webpack_public_path__ + "img/ARCH_04_prew.2f37909b.jpg";